module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ec.a0bb1aae.png";